<form [formGroup]="entryForm">


  <div class="grid-h addressAndMapViewportAdjusted">
    <!-- address input form -->
    <div class="col-md-6 col-sm-6 addressViewportAdjusted" style=" margin-top: 0px">

      <div class="row" style="display: block;">
        <!-- Sucheingabe -->
        <div class="searchFieldWrapper">

          <!-- [ngClass]="{'searchExpanded': suggestionSelected ? true : false}" -->
          <label for="searchInput" class="label">{{translate.instant('address.address')}}</label>
          <nb-form-field id="searchInput" [ngClass]="{'searchExpanded': suggestionSelected ? true : false}">
            <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
            <input #autoInput 
              [ngClass]="{'searchExpanded': suggestionSelected ? true : false}" 
              type="text"
              style="font-weight: bold" 
              nbInput 
              (input)="this.currentSearchInputUpdate.next($event)"
              placeholder="{{translate.instant('address.placeOrAddress')}}" 
              [(ngModel)]="currentSearchInputProxy.input"
              status="primary" shape="round" fieldSize="large" 
              [ngModelOptions]="{standalone: true}" 
              [nbAutocomplete]="auto"
              [scrollStrategy]="'reposition'">
          </nb-form-field>

        </div>

        <!-- <nb-autocomplete #auto (selectedChange)="onSelectionChange($event)"> -->
        <nb-autocomplete class="slideUpDeep" (selectedChange)="handleOnEnter($event)" #auto>

          <!-- <nb-option-group #auto *ngFor="let group of filteredGroups$ | async; trackBy: trackByFn" [title]="group.name" > -->
          <!-- test without trackByFn: -->
          <nb-option-group #auto *ngFor="let group of filteredGroups$ | async;" [title]="group.name">
            <nb-option *ngFor="let option of group.children" [value]="option" (keyup.enter)="test($event)"
              (click)="onSelection(option)">
              {{ option.label }}
            </nb-option> </nb-option-group>
        </nb-autocomplete>


      </div>


    <div *ngIf="context() == 'edit' || entryForm.value.country" class="slideUpQuick">
      <div class="row">
        <!-- street (normal input) -->
        <div class="col-sm-12 col-md-8 conditionalPadding">
          <app-standard-input [parentRef]="this" [field]="entry[0]"> </app-standard-input>
        </div>

        <!-- street number (normal input) -->
        <div class="col-xs-12 col-sm-12 col-md-4 conditionalPadding">
          <app-standard-input [parentRef]="this" [field]="entry[1]"> </app-standard-input>
        </div>

      </div>

      <div class="row">
        <!-- city (normal input) -->
        <div class="col-sm-12 col-md-8 conditionalPadding">
          <app-standard-input [parentRef]="this" [field]="entry[2]"> </app-standard-input>
        </div>

        <!-- zip code (normal input) -->
        <div class="col-xs-12 col-sm-12 col-md-4 conditionalPadding">
          <app-standard-input [parentRef]="this" [field]="entry[3]"> </app-standard-input>
        </div>
      </div>

      <div class="row">
        <!-- city (normal input) -->
        <div class="col-12 conditionalPadding">
          <app-standard-input [parentRef]="this" [field]="entry[4]"> </app-standard-input>
        </div>

      </div>


    </div>

    </div>

    <!-- map -->
    <div class="col-md-6 col-sm-6 mapViewportAdjusted" #mapContainer
      style="display: inline-flex; padding-left: 0px; margin-top: 0px">
      <google-map *ngIf="showMap" class="googleMap" [center]="mapPinPosition.lat ? mapPinPosition : mapCenterDefault" [options]="mapOptions" [zoom]="13"
        width="{{mapWidth}}px" height="{{mapHeight}}px">
        <map-marker *ngIf="mapPinPosition?.lat && mapPinPosition?.lng" [position]="mapPinPosition" [options]="markerOptions"></map-marker>
      </google-map>
    </div>




  </div>

  <!-- button -->
  <div class="form-group row">

    <!-- Debug: use this button to show current state of input form/validation -->
    <!-- <div class="col-sm-9" style="margin-top: 25px;">
      <button type="submit" (click)="logForm()" nbButton status="primary" nbButton matRipple status="primary"
        size="large" nbSpinnerStatus="primary" nbSpinnerSize="large" nbSpinnerMessage="">Log Form State</button>
    </div> -->

  </div>

</form>